<template>
    <div class="alert-final">
        <div class="alert-final-container">
            <div class="image-alert">
                <img class="image" src="../../assets/success-icon.png" alt="">
            </div>
            <div class="text-alert">
                <div class="title-alert">
                    <span class="title">{{typeExtract != 'group-hit' ? $t("components.Alerts.AlertCorrect.title") : nameCorrect }}</span>
                    <span class="subtitle" v-if="typeExtract == 'group-hit'">{{$t("components.Alerts.AlertCorrect.subtitles[0]")}}</span>
                </div>
                <div class="sub-title-alert">{{$t("components.Alerts.AlertCorrect.subtitles[1]")}}</div>
            </div>
            <div class="button-alert" @click="goDash()">
                <button-default buttonType="team-finish" name="suggestion" classButton="game" :textButton='$t("components.Alerts.AlertCorrect.button")'></button-default>
            </div>
        </div>
    </div>
</template>
<script>
import ButtonDefault from '../Buttons/ButtonDefault.vue'
import firebase from '../../firebase/firebase.js'
export default {
    data(){
        return{
            typeExtract : '',
            nameCorrect : ''
        }
    },
    components : {
        ButtonDefault
    },
    methods : {
        goDash(){
            this.$router.push('/feedback360')
        },
        playerCorrect(attempts, group){
            let player = attempts.filter(attempt => {
                return attempt.enigmaOrder == 'equation' && attempt.correct == true
            })
            if(!player[0]){
                return
            }
            let playerId = player[0].userId
            let groupPlayer = group.filter(member => {
                return member.id == playerId
            })
            this.nameCorrect = groupPlayer[0].name
        }
    },
    async created(){
        await firebase.destroyedApp()
        const db = firebase.constructDB()
        const { teamGameId, selfPlayer, group, typeExtract } = this.$store.getters.getSimple(['teamGameId', 'selfPlayer', 'group', 'typeExtract'])
        this.typeExtract = typeExtract
        const teamGame = await db.collection('teamGames').doc(teamGameId).get()
        let attempts = teamGame.data().attempts
        if(typeExtract == 'group-hit'){
            this.playerCorrect(attempts, group)
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-final{
        width: 100%;
        height: 100vh;
        background: #30353a;

        .alert-final-container{

            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .image-alert{
                // height: 20%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: flex-end;

                .image{
                    height: 345px;
                }
            }

            .text-alert{
                height: 20%;
                width: 100%;
                margin: 8% 0 0;
                text-align: center;
                

                .title-alert{
                    font-size: 53px;
                    color: #41f0ad;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-weight: 900;
                    margin: -72px auto 32px;
                    line-height: 47px;

                    .title{
                        width: 75%;
                        text-align: center;
                    }

                    .subtitle{
                        font-size: 21px;
                        font-weight: 900;
                        margin-top: 6px;
                    }
                }

                .sub-title-alert{
                    color: white;
                    width: 75%;
                    margin: 0 auto;
                    font-weight: 100;
                }
            }

            .button-alert{
                height: 10%;
                width: 50%;
            }
        }
    }
</style>
